import { render, staticRenderFns } from "./StatsProdPrevDay.vue?vue&type=template&id=1fde448a&scoped=true&lang=html&"
import script from "./StatsProdPrevDay.vue?vue&type=script&lang=js&"
export * from "./StatsProdPrevDay.vue?vue&type=script&lang=js&"
import style0 from "./StatsProdPrevDay.vue?vue&type=style&index=0&id=1fde448a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde448a",
  null
  
)

export default component.exports